import { IsNotEmpty, IsNumber, IsOptional } from "class-validator";

import { IHerdingElementDeduction } from "./herding-element-deduction.interface";

export class HerdingElementDeductionDto implements IHerdingElementDeduction {
  //
  @IsNotEmpty()
  element_name: string;

  @IsOptional()
  @IsNumber()
  points_deducted: number;
}
